import { TRACK_HELP_CHAT_EVENT } from "./constants";

export const initialState = {
  key: undefined,
  value: undefined,
  skipUpdate: false, // do not update value if it is already set (ex: first attended event name, etc)
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @typescript-eslint/default-param-last
const helpChatReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TRACK_HELP_CHAT_EVENT:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};

export default helpChatReducer;
